import './PendingPaymentListComponent.scss';
import TableWrapperComponent from "../../../shared/components/table-wrapper/TableWrapperComponent";
import {APIConfig} from "../../../constants";
import {ITableColumn} from "../../../shared/models/table.model";
import LinkComponent from "../../../shared/components/link/LinkComponent";
import {CommonService} from "../../../shared/services";
import moment from "moment-timezone";
import ToolTipComponent from "../../../shared/components/tool-tip/ToolTipComponent";
import ChipComponent from "../../../shared/components/chip/ChipComponent";
import ButtonComponent from "../../../shared/components/button/ButtonComponent";
import {useMemo, useState} from "react";
import SecureCheckoutComponent from "../secure-checkout/SecureCheckoutComponent";
import ModalComponent from "../../../shared/components/modal/ModalComponent";

interface PendingPaymentListProps {
    filterState: any;
    onSort: (key: string, order: string) => void;
};


const PendingPaymentListComponent = (props: PendingPaymentListProps) => {
    const [isSecureCheckOutModalOpen, setIsSecureCheckOutModalOpen] = useState(false);
    const [selectedId, setSelectedId] = useState('');
    const [refreshToken, setRefreshToken] = useState<string>('');
    const pendingPaymentListColumns: ITableColumn[] = useMemo(() => [
        {
            title: 'Invoice No.',
            key: 'invoice_no',
            dataIndex: 'invoice_no',
            fixed: 'left',
            render: (record: any) => {
                return (
                    <>
                        {record?.invoice_number}
                    </>
                )
            }
        },
        {
            title: 'Billing Date',
            key: 'billing_date',
            dataIndex: 'billing_date',
            align: 'center',
            render: (record: any) => {
                return (
                    <>
                        {CommonService.getDateFromTimezone(record?.created_at, moment.tz.guess(), 'DD-MMM-YYYY')}
                    </>
                )
            }
        },
        {
            title: 'Service Name',
            key: 'service',
            dataIndex: 'service',
            align: 'center',
            width: 200,
            render: (record: any) => {
                return (<>
                        <ToolTipComponent tooltip={<>
                            {record?.category_details?.name}<br/> {record?.service_details?.name}
                        </>
                        }>
                            <div>{CommonService.getFirstLetterOfEachWord(record?.category_details?.name) + (record?.category_details?.name?.length ? " - " : '') + CommonService.truncateName(record?.service_details?.name, 15)}</div>
                        </ToolTipComponent>
                    </>
                )
            }
        },
        {
            title: 'Provider Name',
            key: 'provider_name',
            dataIndex: 'provider_name',
            sortable: true,
            align: 'center',
            render: (record: any) => {
                return (
                    <>
                        {record?.provider_name || 'N/A'}
                    </>
                )
            }
        },
        {
            title: 'Total Amount',
            key: 'total_amount',
            dataIndex: 'total_amount',
            align: 'center',
            render: (record: any) => {
                return (
                    <>
                        ${CommonService.convertToDecimals(record?.payable_amount)}
                    </>
                )
            }
        },
        {
            title: 'Payment For',
            key: 'payment_for',
            dataIndex: 'payment_for',
            align: 'center',
            sortable: true,
            render: (record: any) => {
                return (
                    <>
                        <ChipComponent label={record?.payment_for} className={record?.payment_for}/>
                    </>
                )
            }
        },
        {
            title: 'Billing Status',
            key: 'billing_status',
            dataIndex: 'billing_status',
            align: 'center',
            render: (record: any) => {
                return (
                    <ButtonComponent variant={'outlined'} color={'error'} size={'small'} onClick={() => {
                        if (record?.enable_pay_now === false) {
                            CommonService._alert.showToast('This appointment has been marked as cancelled or no-show. Payment is not allowed unless the status is updated by the admin.')

                        } else {
                            setIsSecureCheckOutModalOpen(true);
                            setSelectedId(record._id);
                        }
                    }}>

                        Pay Now
                    </ButtonComponent>
                )
            }
        },
        {
            title: 'Action',
            key: 'action',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            render: (record: any) => {
                return (
                    <>
                        <LinkComponent
                            route={CommonService._routeConfig.TransactionDetails(record._id) + '?type=invoice'}>
                            View Details
                        </LinkComponent>
                    </>
                )
            }
        }
    ], []);

    const {filterState, onSort} = props;

    return (
        <div className="pending-payment-list">
            <TableWrapperComponent url={APIConfig.GET_PENDING_PAYMENT_LIST.URL}
                                   method={APIConfig.GET_PENDING_PAYMENT_LIST.METHOD}
                                   extraPayload={filterState}
                                   onSort={onSort}
                                   refreshToken={refreshToken}
                                   noDataText={!filterState ? "No invoices are available at this time." : "No invoice was found for the applied filter."}
                                   columns={pendingPaymentListColumns}/>

            <ModalComponent isOpen={isSecureCheckOutModalOpen}
                            closeOnBackDropClick={false}
            >
                <SecureCheckoutComponent isComingFromListScreen={true}
                                         selectedId={selectedId}
                                         setRefreshToken={setRefreshToken}
                                         setIsSecureCheckOutModalOpen={setIsSecureCheckOutModalOpen}/>
            </ModalComponent>
        </div>
    );
};

export default PendingPaymentListComponent;
